import { STUDENT_SEX_LABEL_KEYS } from "constants/studentSex";

const LEGACY_TO_SEX = {
  male: "male",
  m: "male",
  masculin: "male",
  homme: "male",
  female: "female",
  f: "female",
  féminin: "female",
  feminin: "female",
  femme: "female",
  femenino: "female",
};

/**
 * Maps legacy gender/sex strings to canonical male|female|null.
 * @param {unknown} input
 * @returns {'male'|'female'|null}
 */
export function normalizeStudentSex(input) {
  if (input === undefined || input === null) return null;
  const s = String(input).trim();
  if (!s) return null;
  const key = s.toLowerCase();
  if (LEGACY_TO_SEX[key]) return LEGACY_TO_SEX[key];
  if (s === "Male" || s === "MALE") return "male";
  if (s === "Female" || s === "FEMALE") return "female";
  return null;
}

/**
 * Localized display label for a student sex code.
 * @param {unknown} sex - Raw sex from API/DB
 * @param {(key: string, fallback?: string) => string} t
 * @returns {string}
 */
export function formatStudentSex(sex, t) {
  const normalized = normalizeStudentSex(sex);
  if (!normalized) return "—";
  const key = STUDENT_SEX_LABEL_KEYS[normalized];
  if (!key || !t) {
    return normalized === "male" ? "Male" : "Female";
  }
  return t(key, normalized === "male" ? "Male" : "Female");
}
